module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABHNCSVQICAgIfAhkiAAAASpJREFUSIntlkFuhDAMRV+quUIExwknA05GepuiHIIuGjIMxMEwtOqCL7EALL9gm5/ArVsZhZouVEyhYgo13d9Dn9eQiRlCjZPymANAx0QLYjKPoQdgei7EjnnGhxLaxWQSFMApYpJ2vzhCW02ynE598bvQkkRwqBiugEoDtgHPU4uyV7ua8tP9Av610v7AuyxYAfUYGjti7IjB0GDoX+7BF+DtEp4mLpZXhNqRpvA+aSdPmvJlqb0YPRuDRuXYxHgsVtKsrM+pYdvk65Z5DJ9Z8AyH1O8l2FGqSEmG3n5tNxKVZR6S8q/QgVcTKSnGuOvACvhRDzhWagF+xniO93gFP+t2j/0QAV5FWNEuZF0/1f8I7HMPxRPInudqJZ1A5B4bmre2yJVF3voGeV6DpHlUMdoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/icon_Department@2x.png
// module id = fPAm
// module chunks = 1